<template>
    <EvalIntro v-if="showIntro" @on-start="gotoEvalTest" />
    <div v-if="!showIntro" style="display: flex">
        <SiderLayer />
        <div style="width: 90%; padding: 3.2vw 2.3vw">
            <div>
                <div class="row full-width flex items-center + justify-between mypage--top">
                    <!-- <div class="mypageLayout10"> -->
                    <p class="mypage__title">
                        <!-- <p class="tt100">tt100</p>
                        <p class="tt1000">tt1000</p> -->
                        <!-- <p  style="font-size: 46px; font-weight: 700;">진단평가</p> -->
                        <span class="mypageTt10">{{ userName }} 학생 반가워요!</span>
                        <span class="mypageTt20">{{ userSchool }} {{ getStringUserGrade }}</span>
                    </p>
                    <!-- <p class="modify-info" :onClick="onMyInfo">내 정보 수정</p> -->
                    <!-- <CusButton :type="475" :label="`내 정보 수정`" @onReturn="onMyInfo" /> -->
                </div>
                <div class="flex items-center + justify-between mypage__content">
                    <q-card flat :onClick="onNotify" class="notify" style="cursor: pointer">
                        <q-item class="my-card">
                            <q-card-actions>
                                <img src="@/assets/images/icon/img_notice.png" />
                            </q-card-actions>
                            <q-item-section>
                                <q-item-label class="mypageMenuTt10">알림 </q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-card>
                    <q-card flat :onClick="onSetting" class="setting" style="cursor: pointer">
                        <q-item class="my-card">
                            <q-card-actions>
                                <img src="@/assets/images/icon/ico_set.png" />
                            </q-card-actions>
                            <q-item-section>
                                <q-item-label class="mypageMenuTt10">설정</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-card>
                </div>
                <q-card flat :onClick="onEvaluation" class="eval-test" style="cursor: pointer">
                    <q-item class="my-card items-center">
                        <div class="flex items-center">
                            <p class="eval__img"><img src="@/assets/images/icon/ico_diagnosis_green.png" /></p>
                            <p class="kread__logo"><img src="@/assets/images/icon/kread_logo_new_green.svg" /></p>
                            <q-item-label class="mypageMenuTt10 eval__label">진단평가 </q-item-label>
                        </div>
                        <p>
                            <q-btn flat round class="caption3 color_gray_500" icon="arrow_forward_ios" />
                        </p>
                    </q-item>
                </q-card>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { getUserInfo } from '@/api/modules/mypage.js';
import { apiLogin4Member } from '@/api/modules/eval_api.js';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import EvalIntro from '@/views/eval_login/EvalIntro.vue';
import EvalInfo from '@/views/eval_login_mem/index.vue';
import CusButton from '@/components/widget/CusButton.vue';

import Comm from '@/components/common.js';

import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { monitoringLog } from '@/api/modules/monitoring';

// console.log('--mypage-282828');
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const userName = ref();
const userSchool = ref();
const userGrade = ref();

const getStringUserGrade = computed(() => {
    return userGrade.value === 'A' ? '성인' : Comm.getHakNyoun(userGrade.value);
});

const showInfo = ref(false); // for 진단평가
const showIntro = ref(false); // for 진단평가

const setUserData = async () => {
    const res = await getUserInfo(gStore.token);
    if (res) {
        // console.log('--info-res-', res);
        if (res.status === 200) {
            const data = res.data.data;
            userName.value = data.studentName;
            userSchool.value = data.schoolName;
            userGrade.value = data.grade;
        }
    }
};
onMounted(() => {
    setUserData();

    // gStore.selected_kread && gStore.setSelectedKread('');
    // console.log('gStore.selected_kread : ', gStore.selected_kread);
    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('mypage monitoringLog API response ===', res);
    });
});
////////////////////////////----OnClick----////////////////////////////
const onMyInfo = () => {
    router.push('/userinfo');
    // router.push('/check');
    // const data1 = { name: 'mypageModify', query: { aaa: 'aaatest', bbb: 'bbbtest' } };
    // router.push(data1);
};

const onEvaluation = () => {
    router.push('/eval-member');
};
const onIntro = () => {
    showIntro.value = true;
};

const onNotify = () => {
    gStore.setIsFromMypage(true);
    router.push('/inform');
};
const onSetting = () => {
    router.push('/settings');
};
// const onCS = () => {
//     dStore.openConfirmDialog({
//         message: `준비중입니다.`,
//         cancel: '닫기',
//         ok: '확인',
//     });
// };
</script>

<style scoped lang="scss">
p {
    margin-bottom: 0;
}

img {
    width: 100%;
}

.mainBtn {
    width: 400px;
    height: 300px;
    margin: 20px;
    border-radius: 30px;
    border: 1px solid #e0e0e0;
    font-size: 1.4rem;
    font-weight: bold;
    background-color: #f2f2f2;
}

::v-deep {
    .mypage__content {
        margin-top: 4vw;
        .q-card {
            width: calc((100% - 2vmin) / 2);
            border: 1px solid $color_gray_400;
            @include border-radius(1vw);
            background: $color_gray_100;

            &__actions {
                margin-right: 3.33vmin;
                padding: 0;
                width: 7.2vw;
                height: 7.2vw;
            }
        }

        .q-item {
            padding: 5.67vmin 6.67vmin;

            &__label {
                font-size: 1.8vw;
                font-weight: 700;
                line-height: 2.6vw !important;
            }
        }
    }

    .eval {
        &-test {
            img {
                width: 100%;
            }
            .q-item {
                justify-content: space-between;
                padding: 2vmin 8.33vmin;
                &__label {
                    font-size: 1.8vw;
                    line-height: 2.6vw;
                }
            }

            .kread__logo {
                width: 6.35vw;
                margin-left: 2vmin;
                margin-right: 1.33vmin;
                line-height: 0;
            }
        }

        &__img {
            width: 5vw;
            line-height: 0;
        }
    }
}
.mypage {
    &__title {
        span {
            display: block;
        }
        .mypageTt20 {
            margin-top: 0.67vmin;
        }
    }
}
.modify-info {
    padding: 0.75vmin 2.5vmin;
    border: 1px solid $color_gray_900;
    @include border-radius(0.67vmin);
    font-size: 1vw;
    font-weight: 700;
    color: $color_gray_900;
    line-height: 1.6vw;
    cursor: pointer;
}

.eval-test {
    margin-top: 2vmin;
    @include border-radius(1vw);
    background: #eaf8ee;
}
</style>
